import numeral from 'numeral';

// ----------------------------------------------------------------------

export const fNumber = (value, digits = 2) => {
  if (value === null || value === undefined || value === "") return "0.00";
  const n = Number(String(value).replace(/,/g, ""));
  if (!Number.isFinite(n)) return "0.00";
  return new Intl.NumberFormat('en-US', {
    minimumFractionDigits: digits,
    maximumFractionDigits: digits,
  }).format(n);
};

export function fCurrency(number) {
  if (number === null || number === undefined || number === "") return "";
  return `₦${fNumber(number)}`;
}

export const formatWithCommas = (val) => {
  if (val === null || val === undefined || val === "") return "";
  const clean = String(val).replace(/[^0-9.]/g, "");
  const parts = clean.split(".");
  const intPart = parts[0] ? Number(parts[0]).toLocaleString("en-US") : "";
  if (parts.length > 1) {
    return `${intPart}.${parts.slice(1).join("").slice(0, 2)}`;
  }
  return intPart;
};

export const formatToTwoDecimals = (val) => {
  if (val === null || val === undefined || val === "") return "";
  const num = parseFloat(String(val).replace(/,/g, ""));
  if (isNaN(num)) return "";
  return num.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};

export function fPercent(number) {
  const format = number ? numeral(Number(number) / 100).format('0.0%') : '';

  return result(format, '.0');
}

export function fShortenNumber(number) {
  const format = number ? numeral(number).format('0.00a') : '';

  return result(format, '.00');
}

export function fData(number) {
  const format = number ? numeral(number).format('0.0 b') : '';

  return result(format, '.0');
}

function result(format, key = '.00') {
  const isInteger = format.includes(key);

  return isInteger ? format.replace(key, '') : format;
}
